import React from "react";
import "../work.css";
import tastyDineImg from "../images/restoproject.png";
import weatherAppImg from "../images/weather.png";
import AImage from "../images/AImage.png"; 
import Ecom from "../images/Ecom.png"; 

const projects = [
  {
    title: "Tasty Dine - Restaurant Website",
    image: tastyDineImg,
    liveLink: "https://tastydineresto.netlify.app/",
    githubLink: "https://github.com/mdshoaib03/TastyDineResto",
    tags: ["React", "CSS", "Responsive"]
  },
  {
    title: "Weather App",
    image: weatherAppImg,
    liveLink: "https://weather-app0908.netlify.app/",
    githubLink: "https://github.com/mdshoaib03/Weather",
    tags: ["API", "JavaScript", "CSS"]
  },
  {
    title: "AI Image Generator",
    image: AImage,
    liveLink: "https://taupe-faloodeh-0ea9de.netlify.app/",
    githubLink: "https://github.com/mdshoaib03/AiimageGen",
    tags: ["AI", "React", "Cloudinary"]
  },
  {
    title: "Ecommerce Web Application",
    image: Ecom,
    liveLink: "https://e-store-delta-six.vercel.app/",
    githubLink: "https://github.com/mdshoaib03/ecommerceWeb",
    tags: ["MERN Stack", "Redux", "Payment Gateway"]
  },
];

function Projects() {
  return (
    <section id="projects" className="projects-section">
      <div className="section-header">
        <h2 className="projects-title">MY CREATIONS</h2>
        <div className="title-decoration"></div>
        <p className="projects-subtitle">Projects that showcase my skills</p>
      </div>
      
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div className="project-card" key={index}>
            <div className="project-image-container">
              <a href={project.liveLink} target="_blank" rel="noopener noreferrer">
                <img 
                  src={project.image} 
                  alt={project.title} 
                  className="project-img" 
                  loading="lazy"
                />
                <div className="image-overlay"></div>
              </a>
            </div>
            
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              
              <div className="project-tags">
                {project.tags.map((tag, i) => (
                  <span key={i} className="tag">{tag}</span>
                ))}
              </div>
              
              <div className="project-links">
                <a 
                  href={project.liveLink}
                  className="demo-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Live Demo
                </a>
                <a 
                  href={project.githubLink}
                  className="github-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-github"></i> Code
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <p className="coming-soon">More projects in development...</p>
    </section>
  );
}

export default Projects;